
import {
  RevIllustration,
  RevModal,
  RevSpinner,
} from '@backmarket/design-system'

import { STATUS } from './AsyncModal.constant'
import translations from './AsyncModal.translations'

export default {
  components: {
    RevModal,
    RevIllustration,
    RevSpinner,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      // Sometimes the title is retrieved from the endpoint
      default: '',
    },
    fetch: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      status: STATUS.LOADING,
    }
  },
  computed: {
    translations: () => translations,

    isError() {
      return this.status === STATUS.ERROR
    },
    isLoaded() {
      return this.status === STATUS.SUCCESS
    },
    isLoading() {
      return this.status === STATUS.LOADING
    },
  },
  methods: {
    async onOpen() {
      this.status = STATUS.LOADING

      try {
        await this.fetch()
        this.status = STATUS.SUCCESS
      } catch {
        this.status = STATUS.ERROR
      }
    },
  },
}
